import { render, staticRenderFns } from "./MsiContainer.vue?vue&type=template&id=201c5476&scoped=true&"
import script from "./MsiContainer.vue?vue&type=script&lang=js&"
export * from "./MsiContainer.vue?vue&type=script&lang=js&"
import style0 from "./MsiContainer.vue?vue&type=style&index=0&id=201c5476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c5476",
  null
  
)

export default component.exports